/**
 * Created by shubham on 10/5/18.
 */

import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { APPCONFIG } from '../../../config';
import { MdDialog, MdDialogRef } from '@angular/material';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { HttpService } from '../../../shared/services/http.service';
import { SessionHandler } from '../../../shared/services/session-handler.service';
import { DialogComponent } from '../../../dialog/dialog.component';
import { BuAssignmentDialogComponent } from '../../../dialog/dialog.component';
import {TranslateService} from 'ng2-translate';


@Component({
    selector: 'view-manager',
    template: require('./viewManager.component.html')
})
export class ViewManagerComponent {

    dialogRef;
    userDetails: any;
    id: any;
    ManagerEditForm: FormGroup;
    ManagerEditFormDetails: any;

    managerDetails = [];
    isSystemAdmin: boolean = false;
    isBUManager: boolean = false;
    isRegionalAdmin: boolean = false;
    isServiceOwner: boolean = false;
    isTradePartner: boolean = false;
    isSubUser: boolean = false;
    isDisabled = true;
    admins = [];
    manager_settings = {};
    application_settings = {};
    selectedManagerItems = [];
    selectedManagerItemsCopy = [];
    selectedApplicationItems = [];
    selectedApplicationItemsCopy = [];
    applications = [];

    constructor(private router: Router, private route: ActivatedRoute, private sessionHandler: SessionHandler, public httpService: HttpService, 
        public dialog: MdDialog, private formBuilder: FormBuilder, private translate: TranslateService) {

        this.route.params.subscribe(params => {
            this.id = params['buAssociationId'];
        });

        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(APPCONFIG.systemAdmin)) {
                this.isSystemAdmin = true;
            } else if (this.userDetails.roleCode.includes(APPCONFIG.BUManager)) {
                this.isBUManager = true;
            } else if (this.userDetails.roleCode.includes(APPCONFIG.regionalAdmin)) {
                this.isRegionalAdmin = true;
            } else if (this.userDetails.roleCode.includes(APPCONFIG.serviceOwner)) {
                this.isServiceOwner = true;
            } else if (this.userDetails.roleCode.includes(APPCONFIG.tradePartner)) {
                this.isTradePartner = true;
            } else if (this.userDetails.roleCode.includes(APPCONFIG.subuser)) {
                this.isSubUser = true;
            }
        } else {
            this.httpService.noUserError();
        }

        if (this.isSystemAdmin) {
            this.getManagerDataById(this.id);
            this.getAdmins();
            this.getApplications();
        }
    }

    public getManagerDataById(id) {
        this.httpService.getRequest('superUserOperationsApi/v1/countryBusinessUnitManagerMapping/' + id).subscribe(
            res => { this.saveManagerData(res) },
            err => { this.httpService.onEnd(); }
        );
    }
    public saveManagerData(res) {
        if (res) {
            this.managerDetails = res;

            if (this.managerDetails['managerIds'] && this.managerDetails['managerNames']) {
                for (let l in this.managerDetails['managerIds']) {
                    this.selectedManagerItems.push({ id: this.managerDetails['managerIds'][l], name: this.managerDetails['managerNames'][l] });
                    this.selectedManagerItemsCopy.push({ id: this.managerDetails['managerIds'][l], name: this.managerDetails['managerNames'][l] });
                }
            }

            if (this.managerDetails['applicationId'] && this.managerDetails['applicationName']) {
                for (let l in this.managerDetails['applicationId']) {
                    this.selectedApplicationItems.push({ id: this.managerDetails['applicationId'][l], name: this.managerDetails['applicationName'][l] });
                    this.selectedApplicationItemsCopy.push({ id: this.managerDetails['applicationId'][l], name: this.managerDetails['applicationName'][l] });
                }
            }

            this.ManagerEditFormDetails = this.managerDetails;
            this.buildForm();
            this.httpService.onEnd();
        } else if (res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'data_load_failed';
            this.httpService.onEnd();
        }
    }

    public getAdmins() {
        this.httpService.getRequest('superUserOperationsApi/v1/getCountryAdminList').subscribe(
            res => { this.saveAdmins(res); },
            err => { this.httpService.onEnd(); }
        );
    }
    public saveAdmins(res) {
        if (res && res.items) {
            this.admins = res.items;
        }
        this.httpService.onEnd();
    }

    public getApplications() {
        this.httpService.getRequest('applicationOperationApi/v1/getApplicationDropDownList').subscribe(
            res => { this.saveApplications(res); },
            err => { this.httpService.onEnd(); }
        );

    }
    public saveApplications(res) {
        if (res && res.items) {
            this.applications = res.items;
        }
        this.httpService.onEnd();
    }

    buildForm() {
        this.ManagerEditForm = this.formBuilder.group({
            /*managerId: this.formBuilder.control(this.managerDetails['managerId'], [Validators.required]),*/
            managerData: this.formBuilder.control(null, [Validators.required]),
            applicationData: this.formBuilder.control(null, [Validators.required]),
            buManagerReplacementsData: this.formBuilder.control(null)
        });
        this.ManagerEditForm.valueChanges.subscribe(data => {
            this.ManagerEditFormDetails = this.ManagerEditForm.getRawValue();
            this.ManagerEditFormDetails['buAssociationId'] = this.managerDetails['buAssociationId'];

            this.ManagerEditFormDetails['managerIds'] = [];
            for (let d in this.ManagerEditFormDetails.managerData) {
                this.ManagerEditFormDetails['managerIds'].push(this.ManagerEditFormDetails.managerData[d]['id']);
            }

            this.ManagerEditFormDetails['applicationId'] = [];
            for (let d in this.ManagerEditFormDetails.applicationData) {
                this.ManagerEditFormDetails['applicationId'].push(this.ManagerEditFormDetails.applicationData[d]['id']);
            }
            this.ManagerEditFormDetails['buManagerReplacements'] = [];
            console.log(this.ManagerEditFormDetails);
            
            for (let d in this.ManagerEditFormDetails.buManagerReplacementsData) {
                this.ManagerEditFormDetails['buManagerReplacements'].push({currentId:this.ManagerEditFormDetails.buManagerReplacementsData[d]['currentId'],
                newId:this.ManagerEditFormDetails.buManagerReplacementsData[d]['newId']});
            }
            this.ManagerEditFormDetails.validate = this.ManagerEditForm.valid;
        });
    }

    public updateManagerDetails() {
        console.log(this.tempReplaced);
        
        console.log(this.ManagerEditFormDetails);
        this.httpService.postRequest(this.ManagerEditFormDetails, '/superUserOperationsApi/v1/updateCountryBusinessUnitManagerMapping').subscribe(
            res => { this.saveUpdateManagerResponse(res); },
            err => { this.httpService.onEnd(); }
        );
    }
    public saveUpdateManagerResponse(res) {
        if (res) {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = "Updated Successfully";
            this.dialogRef.afterClosed().subscribe(result => {
                window.location.href = '#/app/manager-assignment/list';
            });
        } else if (res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'save_failed';
            this.httpService.onEnd();
        }
    }

    onDeSelectAll(items: any) {
        this.selectedApplicationItems = Object.assign([], this.selectedApplicationItemsCopy);
        this.ManagerEditForm.controls['applicationData'].setValue(this.selectedApplicationItems);
    }

    OnItemDeSelect(item: any) {
        if (this.selectedApplicationItemsCopy.find(s => s.id === item.id)) {
            this.selectedApplicationItems.push({ id: item.id, name: item.name });
            this.ManagerEditForm.controls['applicationData'].setValue(this.selectedApplicationItems);
        }
    }
    replacementAdmin;
    replacementAdminId;
    removedAdmin;
    tempRemoved: any = [];
    tempReplaced: any = [];
    tempReplacedCopy: any = [];
    tempFlag: boolean = false;
    OnManagerDeSelect(item: any) {
        this.removedAdmin = item;
        if (this.selectedManagerItemsCopy.find(x => x.id == item.id)) {
            console.log(this.selectedManagerItemsCopy.find(x => x.id == item.id).name);
            if (this.tempReplaced.find(x => x.currentId == item.id)) { }
            else { this.tempReplaced.push({ currentId: this.selectedManagerItemsCopy.find(x => x.id == item.id).id }); }
            console.log(this.tempReplaced.find(x => x.currentId == item.id));
            var currentId = this.tempReplaced.find(x => x.currentId == item.id).currentId;
            console.log(this.selectedManagerItemsCopy.find(x => x.id == currentId).name);

            this.dialogRef = this.dialog.open(BuAssignmentDialogComponent);
            this.dialogRef.componentInstance.admins = this.admins;
            this.dialogRef.componentInstance.managerName = this.selectedManagerItemsCopy.find(x => x.id == currentId).name;
            this.dialogRef.afterClosed().subscribe(data => {
                console.log(data);
                if (data) {
                    this.replacementAdmin = data;
                    if(this.tempReplaced.find(x => x.currentId == this.removedAdmin.id)) {
                       
                        console.log(this.tempReplaced);
                        if (this.selectedManagerItemsCopy.find(x => x.id == this.replacementAdmin.id)) {
                            if (this.tempReplaced.find(x => x.currentId == this.replacementAdmin.id)) {
                                this.selectedManagerItems.push({ id: this.replacementAdmin.id, name: this.replacementAdmin.name });
                                this.ManagerEditForm.controls['managerData'].setValue(this.selectedManagerItems);
                            }
                        }
                        else {
                            if (this.tempReplaced.find(x => x.newId == this.replacementAdmin.id)){}
                            else{this.selectedManagerItems.push({ id: this.replacementAdmin.id, name: this.replacementAdmin.name });
                            this.ManagerEditForm.controls['managerData'].setValue(this.selectedManagerItems);}
                    }}
                    this.tempReplaced.find(x => x.currentId == this.removedAdmin.id).newId = this.replacementAdmin.id;
                    console.log(this.tempReplaced);
                    console.log(this.selectedManagerItems);
                    
                    this.ManagerEditForm.controls['buManagerReplacementsData'].setValue(this.tempReplaced);
                }
                else {
                    this.selectedManagerItems.push(this.removedAdmin);
                    this.ManagerEditForm.controls['managerData'].setValue(this.selectedManagerItems);
                }
            });
        }
        else if (this.tempReplaced.find(x => x.newId == this.removedAdmin.id)) {
            console.log(this.tempReplaced.find(x => x.newId == this.removedAdmin.id));
            var selectionId = this.tempReplaced.find(x => x.newId == this.removedAdmin.id).currentId;
            this.dialogRef = this.dialog.open(BuAssignmentDialogComponent);
            this.dialogRef.componentInstance.admins = this.admins;
            console.log(this.selectedManagerItemsCopy.find(x => x.id == selectionId).name);

            this.dialogRef.componentInstance.managerName = this.selectedManagerItemsCopy.find(x => x.id == selectionId).name;

            this.dialogRef.afterClosed().subscribe(data => {
                console.log(data);
                if (data) {
                    this.replacementAdmin = data;
                    if (this.tempReplaced.find(x => x.currentId == selectionId)) {
                        
                        console.log(this.tempReplaced);
                        if (this.selectedManagerItemsCopy.find(x => x.id == this.replacementAdmin.id)) {
                            if (this.tempReplaced.find(x => x.currentId == this.replacementAdmin.id)) {
                                this.selectedManagerItems.push({ id: this.replacementAdmin.id, name: this.replacementAdmin.name });
                                this.ManagerEditForm.controls['managerData'].setValue(this.selectedManagerItems);
                            }
                        }
                        else {
                            if (this.tempReplaced.find(x => x.newId == this.replacementAdmin.id)){}
                            else{this.selectedManagerItems.push({ id: this.replacementAdmin.id, name: this.replacementAdmin.name });
                            this.ManagerEditForm.controls['managerData'].setValue(this.selectedManagerItems);}
                        }}
                        this.tempReplaced.find(x => x.currentId == selectionId).newId = this.replacementAdmin.id;
                        console.log(this.tempReplaced);
                        
                        this.ManagerEditForm.controls['buManagerReplacementsData'].setValue(this.tempReplaced);
                       }
                else {this.selectedManagerItems.push(this.removedAdmin);}});
                this.ManagerEditForm.controls['managerData'].setValue(this.selectedManagerItems);
            }
            console.log(this.tempReplaced);
    }
    ngOnInit() {
        this.buildForm();

        var app_settings = {singleSelection: false,text:"",labelKey: "name",selectAllText:"",unSelectAllText:"",classes:"myclass custom-class"};
        var mgr_settings = {singleSelection: false,text:"",labelKey: "name",selectAllText:"",unSelectAllText:"",classes:"myclass custom-class"};
        this.translate.get('Select Applications').subscribe((res: string) => {app_settings.text = res;
            if(app_settings.text&&app_settings.selectAllText&&app_settings.unSelectAllText) {this.application_settings=app_settings;}
        });
        this.translate.get('Assign Manager').subscribe((res: string) => {mgr_settings.text = res;
            if(mgr_settings.text&&mgr_settings.selectAllText&&mgr_settings.unSelectAllText) {this.manager_settings=mgr_settings;}
        });
        this.translate.get('select_all').subscribe((res: string) => {app_settings.selectAllText=res;mgr_settings.selectAllText=res;
            if(mgr_settings.text&&mgr_settings.selectAllText&&mgr_settings.unSelectAllText) {this.manager_settings=mgr_settings;}
            if(app_settings.text&&app_settings.selectAllText&&app_settings.unSelectAllText) {this.application_settings=app_settings;}
        });
        this.translate.get('unselect_all').subscribe((res: string) => {app_settings.unSelectAllText=res;mgr_settings.unSelectAllText=res;
            if(mgr_settings.text&&mgr_settings.selectAllText&&mgr_settings.unSelectAllText) {this.manager_settings=mgr_settings;}
            if(app_settings.text&&app_settings.selectAllText&&app_settings.unSelectAllText) {this.application_settings=app_settings;}
        });
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/managerAssignment/viewManager/viewManager.component.ts